import { Injectable } from '@angular/core';
import { SimpleUser } from './user.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Page } from './api.service';

export type ActivityType = 'QUIZ' | 'VOLUNTEER_TASK' | 'CLASS_TASK' | 'OTHER' ;
export type ActivityStatus =  'ACTIVE' | 'COMPLETED' | 'CANCELLED'| 'PAUSED' | 'DELETED' ;

export class Activity {

  id?: string;
  roomId?: string;
  agendaIndex?: number ;
  type: ActivityType ;

  status: ActivityStatus;
  createdAt?: Date;

  forGroups: boolean;

  constructor(type: ActivityType, forGroups: boolean) {
    this.type = type ;
    this.status = 'ACTIVE';
    this.forGroups = forGroups ;
  }
}


export interface ActivityResponse {
  id?: string ;
  activityId: string ;
  groupId?: string ;
  userIds?: string[] ;
  type: ActivityType ;
  roomId?: string ;
  pseudo?: boolean ;
  deleted?: boolean ;
}

export interface Adjustment {
  type: ActivityType ;
  explanation: string  ;
  createdBy: SimpleUser ;
  createdAt: Date ;
}


@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(
    private http: HttpClient
  ) {
  }

  getCurrent(roomId: string): Observable<Activity> {
    return this.http.get<Activity>(
      `${environment.apiHost}/rooms/${roomId}/activities/current`
    ) ;
  }

  getResponses(activityId: string, page: number ): Observable<Page<ActivityResponse>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<ActivityResponse>>(
      `${environment.apiHost}/activities/${activityId}/responses`,
      {params}
    ) ;
  }

  getMyResponse(activityId: string): Observable<ActivityResponse> {
    return this.http.get<ActivityResponse>(
      `${environment.apiHost}/activities/${activityId}/responses/mine`,
    ) ;
  }

  updateMyResponse(activityId: string, update: ActivityResponse): Observable<ActivityResponse> {

    return this.http.patch<ActivityResponse>(
      `${environment.apiHost}/activities/${activityId}/responses/mine`,
      {
        update
      }
    ) 
  }

  updateProgress(activityId: string, userOrGroupId:string, update: ActivityResponse): Observable<ActivityResponse> {

    return this.http.patch<ActivityResponse>(
      `${environment.apiHost}/activities/${activityId}/responses/${userOrGroupId}`,
      {
        update
      }
    ) ;
  }

 
  cancel(activityId: string): Observable<Activity> {

    return this.http.delete<Activity>(
      `${environment.apiHost}/activities/${activityId}`,
    ) ;
  }
}
